<template>
  <h4>登录或创建 SSCMS.com 帐户以设置 Cloud 云助手</h4>

  <div style="margin: 30px 0 10px">
    <el-button type="primary" style="width: 100%" @click="btnLoginClick">登 录 SSCMS.com</el-button>
  </div>

  <div style="margin: 10px 0">
    <el-button type="default" style="width: 100%" @click.prevent="btnRegisterClick">注 册 SSCMS.com</el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PAGE_TYPE_LOGIN, PAGE_TYPE_REGISTER } from '../pageType';

export default defineComponent({
  methods: {
    btnLoginClick() {
      this.$emit('redirect', PAGE_TYPE_LOGIN);
    },

    btnRegisterClick() {
      this.$emit('redirect', PAGE_TYPE_REGISTER);
    },
  },
});
</script>
